import { CursorAPI } from "@/components/Cursor";
import { forwardRef } from "react";
import { Container, PlusIcon, SwipeIcon } from "./styles";

export type CarouselPointerProps = {
  icon?: "plus" | "swipe";
};

const CarouselPointer = forwardRef<CursorAPI, CarouselPointerProps>(
  function CarouselPointer(props, ref) {
    const { icon = "plus" } = props;
    return (
      <Container ref={ref} width={160} height={160}>
        {icon === "plus" && <PlusIcon />}
        {icon === "swipe" && <SwipeIcon />}
      </Container>
    );
  }
);

// Cast to fix React 17 + @types/react 18 compatibility issue
export default CarouselPointer as any;
